/* eslint-disable eag/no-index */
export * from './api';
export {filterOutAuctionDuplicates, getAuctionId} from './utils/filterOutAuctionDuplicates';
export {sourcingAuctionApiMock} from './__mocks__/sourcingAuctionApiMock';
export type {
  AuctionFilterCar,
  AuctionLocationResponseBody,
  AuctionSellerRequest,
  AuctionSellerResponseBody,
  AuctionStrictBuyerBranch,
  AuctionStrictBuyerRequest,
  AuctionVehicleDetailResponseBody,
  AuctionVehicleResponseBody,
  AuctionVehiclesFilterRequestBody,
  CreateAuctionUserSeenApiArg,
  CreateAuctionUserSeenApiResponse,
  GetAuctionVehicleCountApiArg,
  GetAuctionVehicleCountApiResponse,
  GetAuctionVehicleDetailApiArg,
  GetAuctionVehicleDetailApiResponse,
  GetAuctionVehicleListApiArg,
  GetAuctionVehicleListApiResponse,
  ListAuctionVehiclesByIdsApiArg,
  ListAuctionVehiclesByIdsApiResponse,
  ListAuctionVehiclesByIdsRequestBody,
} from './types';
